import { type Item, type Order } from "@repo/api";

export const getOrderImage = (order?: Order) => getItemImage(order?.items?.[0]);

export const getItemImage = (item?: Item) =>
  item?.imageVariants?.[0]?.href ??
  item?.childItems?.[0]?.imageVariants?.[0]?.href ??
  item?.imageUrl;
